import {
  containerVars,
  backButton,
  closeButton,
  logoVars,
  customLogo,
  button,
  backButtonText,
  container,
  patientHubContainer,
} from './ScreenHeader.css'
import SVGIcon from '../SVGIcon/SVGIcon'
import { SVGIconType } from '../../models/enums'
import { useAppSelector } from '../../hooks/useAppSelector'
import {
  checkIsPatientHub,
  getLogotype,
  selectMode,
} from '../../features/appConfigSlice'
import { useTranslation } from 'react-i18next'
import { assignInlineVars } from '@vanilla-extract/dynamic'

export interface NormalProps {
  type?: 'normal' | 'transparent'
}

// If `showBackButton === true` then `onBack` should be provided.
export type OptionalProps =
  | {
      showBackButton?: never | false
      onBack?: never
    }
  | {
      showBackButton: boolean
      onBack: () => void
    }

export type OptionalCancelProps =
  | {
      showCancelButton?: never | false
      onCancel?: never
    }
  | {
      showCancelButton: boolean
      onCancel: () => void
    }

export type ScreenHeaderProps = NormalProps &
  OptionalProps &
  OptionalCancelProps

const ScreenHeader = ({
  type = 'normal',
  showCancelButton = false,
  onCancel,
  showBackButton = false,
  onBack,
}: ScreenHeaderProps) => {
  const logotype = useAppSelector(getLogotype)
  const mode = useAppSelector(selectMode)
  const { t } = useTranslation('jumbotron')
  const isPatientHub = useAppSelector(checkIsPatientHub)

  return (
    <>
      <div
        className={`${mode ? containerVars[mode] : container} ${
          isPatientHub ? patientHubContainer : ''
        }`}
      >
        {showBackButton && (
          <button
            className={button}
            onClick={onBack}
            data-testid="back-widget-button"
          >
            <SVGIcon icon={SVGIconType.ChevronLeft} className={backButton} />
            <span className={backButtonText}>{t('back_button')}</span>
          </button>
        )}
        {showCancelButton && (
          <button
            className={button}
            onClick={onCancel}
            data-testid="close-widget-button"
          >
            <SVGIcon icon={SVGIconType.Close} className={closeButton} />
          </button>
        )}

        {logotype && (
          <div
            className={logoVars[type]}
            style={assignInlineVars({
              [customLogo]: `url(${logotype})`,
            })}
          />
        )}
      </div>
    </>
  )
}

export default ScreenHeader
